import { Store } from 'react-redux';

import { combineStates, IImmutableMap, ImmutablePropsMap, MDispatch, ReducerGraphNode, ReducerMap } from './redux';
import { createStore } from './reduxUtils';

// tslint:disable: no-any
const storeInstance: Store<any> | undefined = undefined;
const rootReducerInstance: any | undefined = undefined;

export function createReduxRootDetached<RootProps extends ImmutablePropsMap<RootProps>>(
  hostName: string,
  staticReducerMap: ReducerMap<Partial<RootProps>>
): [ReducerGraphNode<RootProps>, Store<IImmutableMap<RootProps>>] {
  const rootReducer = combineStates<RootProps>(staticReducerMap, undefined, getRootStore);

  const store = createStore(rootReducer.getReducerFunction(), hostName);
  function getRootStore(): Store<IImmutableMap<RootProps>> {
    return store;
  }
  return [rootReducer, store];
}

export function getAppStore<T extends ImmutablePropsMap<T>>(): Store<IImmutableMap<T>> {
  if (storeInstance === undefined) {
    throw new Error('AppStore have not been set');
  }
  return storeInstance;
}

export function getRootReducer<T extends ImmutablePropsMap<T>>(): ReducerGraphNode<T> {
  if (rootReducerInstance === undefined) {
    throw new Error('rootReducer have not been set');
  }
  return rootReducerInstance;
}
